import { Middleware } from "redux";
import { RootState } from "../../../state";
import { serverRequest } from "../../../actions/app/api";
import { APP_URL, POST } from "../../../../_shared/constants";
import { CREATE_USER } from "../../../actions";

export const createUser: Middleware<unknown, RootState> =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    if (action.type === CREATE_USER.START) {
      const { payload, onFinish, ...rest } = action.meta;
      dispatch(
        serverRequest({
          method: POST,
          url: `${APP_URL.user.create}`,
          onFinish,
          payload,
          onSuccess: CREATE_USER.SUCCESS,
          ...rest,
        })
      );
    }
  };
